import RetailReportsForm from "components/Form/RetailReportsForm";

const EditReportPage = () => {
  return <RetailReportsForm type="edit" />;
};

export default EditReportPage;
